import * as actions from "./roles.actions";
import * as types from "./roles.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { RoleReducerType } from "./types";

export type RoleActions = ActionType<typeof actions>;

export const initialState: RoleReducerType = {
  error: null,
  roles: [],
  isLoading: false,
  createdRole: null,
  selectedRole: null,
  meta: {
    total: 0,
    per_page: 0,
    last_page: 0,
    current_page: 0,
  }
};

export const RoleReducer = createReducer<
  RoleReducerType,
  RoleActions
>(initialState)
  .handleAction(actions.getRoleAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.getRoleAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    roles: action.payload.data,
    meta: action.payload.meta
  }))
  .handleAction(actions.getRoleAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(actions.selectRoleAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    createdRole: null,
    selectedRole: null,
    redirectQueue: ''
  }))
  .handleAction(actions.selectRoleAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    selectedRole: action.payload.data,
  }))
  .handleAction(actions.selectRoleAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(actions.updateRoleAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.updateRoleAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    createdRole: action.payload.data,
  }))
  .handleAction(actions.updateRoleAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(actions.createRoleAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.createRoleAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    createdRole: action.payload.data
  }))
  .handleAction(actions.createRoleAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(types.SET_ERROR as any, (state, action) => ({
    ...state,
    error: action.payload.value
  }))
  .handleAction(types.RESET_STATE as any, (state, action) => ({
    ...state,
    error: null,
    createdRole: null,
    selectedRole: null
  }))
